import { inject, Injectable } from '@angular/core';
import { SseReconnectHandler } from '@core/sse/sse-reconnect-handler';
import { ConsensusGridStateService } from './consensus-grid-state.service';
import { ConsensusValuesStateService } from './consensus-values-state.service/consensus-values-state.service';

/**
 * Completions missed while the SSE connection was down never evicted the
 * value cache, so the whole cache is dropped and every open block refetched.
 * The refetch also re-seeds the reconciling state from the SSRM snapshot.
 */
@Injectable()
export class ConsensusReconciliationReconnectHandler implements SseReconnectHandler {
  private readonly consensusGridStateService = inject(
    ConsensusGridStateService,
  );
  private readonly consensusValuesStateService = inject(
    ConsensusValuesStateService,
  );

  onReconnect(): void {
    if (!this.consensusGridStateService.gridApi) return;
    this.consensusValuesStateService.clearCache();
    this.consensusGridStateService.refreshAllOpenBlocks();
  }
}
